import styled from "styled-components";

export default styled.form`
    display: flex;
    flex-flow: ${props => props.flexFlow};
    max-width: 100%;
    z-index: 0;
`;
